export const environment = {
  production: true,
  allowedCompaniesForPurchaseOrder: [1, 261, 273, 274, 275, 276],
  urlDeployment: 'localhost',
  sentryDsn: 'https://ed72dfd9946f2989594a5fbb7dbb32ea@o780420.ingest.us.sentry.io/4507617123565568',
  sentryEnv: 'PROD',
}
